import * as React from 'react';

// Assets
const StartSVG = require('../../assets/illustrations/start.svg') as string;

// Components
import Box from '../../components/Box';
import Typography from '../../components/Typography';

// Component
interface IProps {}

const QuestionDialogConfirm = (props: IProps) => {
  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Box pb={3} align="center">
        <img
          src={StartSVG}
          width={192}
          height={192}
          style={{ margin: 'auto', display: 'block', textAlign: 'center' }}
        />
      </Box>
      <Typography type="headline">Ready to ask your questions?</Typography>
      <Typography type="subheading">
        Keep track of the response at the questions page.
      </Typography>
    </div>
  );
};

// Exports
export default QuestionDialogConfirm;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkPeopleSearch/QuestionDialogConfirm.tsx